import { Component, OnInit } from '@angular/core';
import { AuthService } from '../shared/auth.service';
import { first } from 'rxjs/operators';

@Component({
    selector: 'app-auth-callback',
    templateUrl: './auth-callback.component.html',
    styleUrls: ['./auth-callback.component.scss'],
    standalone: false
})
export class AuthCallbackComponent implements OnInit {

  constructor(
    private authService: AuthService
  ) { }

  public ngOnInit(): void {
    this.authService.callback().pipe(first()).subscribe();
  }

}
